<script setup lang="ts">
import { Star } from 'lucide-vue-next'
</script>
<template>
  <span class="TopMarker"><Star class="h-3 w-3 fill-white" />{{ $t('common.top') }}</span>
</template>
